import { Modal, Box, TextField, Button, Stack } from "@mui/material";
import { useState } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { addChannelRow } from "../../utilities/apiRequests";

export default function AddRowModal({ open, onClose }) {
    const [callSign, setCallSign] = useState("");
    const [affiliate, setAffiliate] = useState("");
    const [loading, setLoading] = useState(false);
    const { getAccessTokenSilently } = useAuth0();

   const handleSave = async () => {
    ///////Validate input for callsign and affiliate
    //special characters, leading/trailing spaces, lenghth, internal spaces, non-empty
        const letterOnlyRegex = /^(?!.*--)[A-Za-z]+-?[A-Za-z]+$/;
        if (callSign.includes(" ") || affiliate.includes(" ")) {
            alert("Call Sign and Affiliate cannot contain spaces.");
            return;
        }
        if (!callSign.trim() || !affiliate.trim()) {
            alert("Call Sign and Affiliate are required and cannot be empty or just spaces.");
            return;
        }
        if (callSign.length > 5 || affiliate.length > 5) {
            alert("Call Sign and Affiliate must be 5 characters or less.");
            return;
        }
        if(callSign.length < 3 || affiliate.length < 3) {
            alert("Call Sign and Affiliate must be at least 3 characters.");
            return;
        }
        if (!letterOnlyRegex.test(callSign) || !letterOnlyRegex.test(affiliate)) {
            alert("Call Sign and Affiliate must contain only letters.");
            return;
        }
        const callSignUpper = callSign.toUpperCase().trim();
        const affiliateUpper = affiliate.toUpperCase().trim();
        setLoading(true);
        try {
            const accessToken = await getAccessTokenSilently({ authorizationParams: { scope: "write:channels" } });
            await addChannelRow(accessToken, callSignUpper, affiliateUpper);
            alert("Row added successfully!");
            window.location.reload();
        } catch (error) {
            console.error("Error adding channel row:", error);
            alert("Error adding row!");
        } finally {
            onClose();
            setCallSign("");
            setAffiliate("");
            setLoading(false);
        }
    };

    return (
         <Modal open={open} onClose={onClose}>
            <Box sx={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                bgcolor: 'background.paper',
                boxShadow: 24,
                p: 4,
                borderRadius: 2,
                minWidth: 300,
            }}>
                <Stack spacing={2}>
                    <TextField
                        label="Call Sign"
                        value={callSign}
                        onChange={e => setCallSign(e.target.value)}
                        fullWidth
                    />
                    <TextField
                        label="Affiliate"
                        value={affiliate}
                        onChange={e => setAffiliate(e.target.value)}
                        fullWidth
                    />
                    <Button variant="contained" color="primary" onClick={handleSave} disabled={loading}>
                        {loading ? "Saving..." : "Save"}
                    </Button>
                </Stack>
            </Box>
        </Modal>
    );
}